import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class BitCrusherEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Bits'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.bitsParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={1}
                        max={8}
                        min={1}
                        />
                      <WetSlider
                        effectNumber={this.props.effectNumber}
                    sequencerEngine={this.props.sequencerEngine}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                         onParameterChanged={this.props.onParameterChanged}
                            effect={this.state.effect}/>
                 </div>} 
            </div>
        );
    }
}

export default BitCrusherEffect;
